module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABEUlEQVQ4T9WU7TVEQRBEb0VABsjAZmAjQASIQAgIQQSIgI0AGWwGKwQiKKec9xx25+Otf/rvdN/pqalu0Qjbu8AZcDikLYEHSe+1MtUObAfyDAT6M96AU0mBb0QLmMK9yoVLSbPJQNsnwGNLDmBW6rLYoe1r4KoDvJGUvF/xf4HnwF3nyReS7qc+eR9YdYAHkuKEvobJsP0EHFegC0lxwlY+TJcx785a1Ucmp9Rd8qrGHros2adol/HSHrBk8Lmkl5q+rdHLkzMt42IYGZEh0OKC2ADaPho+I9ZZXwwjNLDI8bo+fl/AAXIJFH+uY5/AI8FtpNDERdBhfh/PA2z5bSpozFsE6G2rWvkBVi3wl4s+AZvQaLgWUvvMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/people-icon.png
// module id = YhbP
// module chunks = 3